import React, { useMemo } from "react";
import { DownloadAsExcelSheet } from "../../components";

export const DownLoadVoterData = ({ voterData, cols }) => {
  return (
    <>
      <DownloadAsExcelSheet data={voterData} cols={cols} name={"Voter List"} />
    </>
  );
};
